import Content from '../../content.js';

namespace('IO.Views.Locations', function (exports) {
  'use strict';

  let locationName, locationTemplateName;

  var Edit = Content.extend({
    render: function () {
      locationName = $('#location-name');
      locationTemplateName = $('#location-template-name');

      this.attachTemplateNameGenerator();
      this.initializeHostnamesDropdown('nodes');
      this.initializeHostnamesDropdown('servers');
    },

    initializeHostnamesDropdown: function (model) {
      $(`#assigned-${model}`).select2({
        placeholder: `Specify a ${model.slice(0, -1)}...`,
        language: {
          searching: function () {
            return 'Loading...';
          },
        },
        minimumInputLength: 0,
        ajax: {
          type: 'GET',
          url: `/${currentCustomer}/${model}/hostnames`,
          dataType: 'json',
          delay: 500,
          cache: true,
          data: function (params) {
            return { search: params.term, page: params.page || 1 };
          },
          processResults: function (data) {
            return {
              results: data.results.map(function (item) {
                return { id: item[0], text: item[1] };
              }),
              pagination: { more: data.pagination.more },
            };
          },
        },
      });
    },

    attachTemplateNameGenerator: function () {
      locationName.on(
        'input',
        function (event) {
          locationTemplateName.val(
            this.cleanUpLocationName(event.target.value),
          );
        }.bind(this),
      );
    },

    cleanUpLocationName: function (locationName) {
      return locationName
        .toLowerCase()
        .replace(/\s+/g, '')
        .replace(/[^a-z0-9-]/g, '')
        .replace(/-+/g, '-')
        .replace(/^-+/, '')
        .slice(0, 20)
        .replace(/-+$/, '');
    },
  });

  exports.Edit = Edit;
});
